import React, { useEffect, useRef, useState } from "react";
import {
  FaReact, FaNodeJs, FaPython, FaCss3Alt, FaGitAlt, FaDocker, FaAws, FaFigma,
} from "react-icons/fa";
import {
  SiJavascript, SiTypescript, SiMongodb, SiPostgresql, SiPhp, SiLaravel,
} from "react-icons/si";
import { skills } from "../../data/portfolioData";
import { useLanguage } from "../../context/LanguageContext";
import "./About.css";

const iconMap = {
  FaReact: <FaReact />,
  SiJavascript: <SiJavascript />,
  SiTypescript: <SiTypescript />,
  FaNodeJs: <FaNodeJs />,
  FaPython: <FaPython />,
  FaCss3Alt: <FaCss3Alt />,
  FaGitAlt: <FaGitAlt />,
  SiMongodb: <SiMongodb />,
  SiPostgresql: <SiPostgresql />,
  SiPhp: <SiPhp />,
  SiLaravel: <SiLaravel />,
  FaDocker: <FaDocker />,
  FaAws: <FaAws />,
  FaFigma: <FaFigma />,
};

const About = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="about" id="about" ref={sectionRef}>
      <div className="about__container">
        <h2 className="section-title">{t.about.title}</h2>
        <p className="section-subtitle">{t.about.subtitle}</p>

        <div className="about__grid">
          {/* Bio */}
          <div className={`about__bio ${visible ? "animate-slide-right" : ""}`}>
            <p className="about__text">{t.about.bio}</p>

            <div className="about__fun-facts">
              <h3>{t.about.factsTitle}</h3>
              <ul>
                {t.about.facts.map((fact, idx) => (
                  <li key={idx}>{fact}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Skills */}
          <div className={`about__skills ${visible ? "animate-slide-left" : ""}`}>
            <h3>{t.about.skillsTitle}</h3>
            <div className="skills__categories">
              {skills.map((group, gIdx) => (
                <div
                  className="skills__category-card"
                  key={gIdx}
                  style={{ animationDelay: `${gIdx * 0.12}s` }}
                >
                  <h4 className="skills__category-title">{t.about.categories[group.category]}</h4>
                  <div className="skills__tags">
                    {group.items.map((skill, idx) => (
                      <span className="skill-tag" key={idx}>
                        <span className="skill-tag__icon">{iconMap[skill.icon]}</span>
                        {skill.name}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
